module.exports = __webpack_public_path__ + "img/prestercito_de_cabeza.ceaacc30.svg";